export default function PasswordStrength({ password }: { password: string }) {
  if (!password) return null;

  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  const labels = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'];
  const colors = ['#FF445F', '#FF8C20', '#2F80ED', '#22C55E', '#22C55E'];
  const widths = ['20%', '40%', '60%', '80%', '100%'];

  const idx = Math.min(score, 4);

  return (
    <div className="mt-2">
      <div className="h-1.5 w-full overflow-hidden rounded-full" style={{ background: 'rgba(255,255,255,0.12)' }}>
        <div className="h-full rounded-full transition-all" style={{ width: widths[idx], background: colors[idx] }} />
      </div>
      <p className="font-body mt-1 text-[10px]" style={{ color: colors[idx] }}>{labels[idx]}</p>
    </div>
  );
}
